module.exports = __webpack_public_path__ + "img/StarMoon.e5a07531.svg";